/* eslint-disable react/no-danger */
import { Button } from '@micromag/core/components';
import Viewer from '@micromag/viewer';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { simplifyMicromag } from '../../../../lib/utils';

// import MicromagPreview from '../../../partials/MicromagPreview';
import MicromagVideo from '../../../partials/MicromagVideo';
import {
    Vibrer,
    TNM,
    Jeux,
    Living,
    Laval,
    PhosphoreTrump,
    CPA,
    Rolex,
    Libertinage,
} from '../../data';

import styles from '../../../../../styles/guest/sections/content/cases.module.scss';

import cases from '../../data/cases.json';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const stories = [TNM, Laval, Vibrer, PhosphoreTrump, CPA, Jeux, Rolex, Living, Libertinage];

const Cases = ({ active, className }) => {
    const { locale } = useIntl();
    const casesRef = useRef(null);
    const items = useMemo(() => stories.map((s) => simplifyMicromag(s)), [stories]);
    const [index, setIndex] = useState(0);

    const micromagValue = useMemo(() => {
        const currentItem = typeof items[index] !== 'undefined' ? stories[index] : null;
        const { components = [] } = currentItem || {};
        return {
            ...currentItem,
            components: components.slice(0, 3),
        };
    }, [items, index]);

    const { id: currentId = null } = micromagValue || {};

    const onClick = useCallback(
        (newIndex) => {
            const { current: casesElement = null } = casesRef;
            if (casesElement !== null) {
                casesElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest',
                });
            }
            setIndex(newIndex);
        },
        [setIndex],
    );

    const viewer =
        micromagValue !== null ? (
            <Viewer
                story={micromagValue}
                className={styles.viewer}
                memoryRouter
                withNavigationHint
            />
        ) : null;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.active]: active,
                },
            ])}
            ref={casesRef}
        >
            <div className={styles.description}>
                <h5 className={styles.surtitle}>
                    <span>
                        <FormattedMessage defaultMessage="Case studies" description="Guest title" />
                    </span>
                </h5>
                <h5 className={styles.subtitle}>
                    <span>
                        <FormattedMessage
                            defaultMessage="View more case studies :"
                            description="Guest title"
                        />
                    </span>
                </h5>
                <div className={styles.micromags}>
                    {(items || []).map((story, idx) => (
                        <Button className={styles.button} onClick={() => onClick(idx)}>
                            <MicromagVideo
                                key={`mm-${story.id}`}
                                story={story}
                                className={classNames([
                                    styles.preview,
                                    { [styles.current]: idx === index },
                                ])}
                                isPoster
                            />
                        </Button>
                    ))}
                </div>
                <div className={styles.cases}>
                    {Object.keys(cases).map((id) => {
                        const { title = null, description = null } = cases[id] || {};
                        return (
                            <div
                                className={classNames([
                                    styles.case,
                                    { [styles.active]: currentId === id },
                                ])}
                            >
                                {title != null ? (
                                    <h2 className={styles.title}>{title[locale]}</h2>
                                ) : null}
                                {micromagValue != null ? (
                                    <div className={styles.mobileMicromag}>{viewer}</div>
                                ) : null}
                                {description != null ? (
                                    <div
                                        className={styles.descriptionInner}
                                        dangerouslySetInnerHTML={{ __html: description[locale] }}
                                    />
                                ) : null}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className={styles.micromag}>{micromagValue != null ? viewer : null}</div>
        </div>
    );
};

Cases.propTypes = propTypes;
Cases.defaultProps = defaultProps;

export default Cases;
